<template>
  <div id="consent-step">
    <!-- Close button -->
    <div @click="close" class="absolute pin-t pin-r py-6 px-4 cursor-pointer"><img src="../assets/img/close-white.svg" class="w-6" /></div>
    <!-- Text -->
    <div class="text-base text-white p-4 md:p-6 md:text-lg">
      <p class="heading first">Your task</p>
      <p>Upload an image that best reflects your experience of nature or society in your local area.</p>
    </div>
    <!-- Buttons -->
    <div class="flex p-6 md:pt-0 border-t md:border-none">
      <csf-button type="primary" @click="agree" class="mr-4">I agree</csf-button>
      <csf-button @click="close" class="mr-4">Back</csf-button>
    </div>
  </div>
</template>

<script>
import CsfButton from "../components/csf-button.vue";

export default {
  name: "consent-step",
  components: { CsfButton },
  methods: {
    close() {
      this.$router.push({ name: "browse" });
    },
    agree() {
      this.$store.commit("transition", { action: "AGREE" });
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 1rem;
}

p.heading {
  font-weight: bold;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
  &.first {
    margin-top: 0;
  }
}
</style>





// WEBPACK FOOTER //
// ConsentStep.vue?12972c23